/**
 * Public system settings
 */
import unauthenticatedApi from "@/utils/unauthenticatedAxios";
import type { SystemSettingResponse } from "@/types/systemSettings.types";

const PUBLIC_SETTINGS_PATH = "/public/system-settings";
const AI_SETTING_KEY = "aiCategorySuggestionEnabled";
const MAINTENANCE_SETTING_KEY = "maintenanceModeEnabled";
const ADDRESS_AUTOCOMPLETE_SETTING_KEY = "addressAutocompleteEnabled";
const ML_SMART_SEARCH_SETTING_KEY = "mlSmartSearchEnabled";

export async function fetchPublicSystemSettings(): Promise<SystemSettingResponse[]> {
  const response =
    await unauthenticatedApi.get<SystemSettingResponse[]>(PUBLIC_SETTINGS_PATH);
  return response.data;
}

export async function getAiCategorySuggestionEnabled(): Promise<boolean> {
  try {
    const settings = await fetchPublicSystemSettings();
    const match = settings.find((setting) => setting.key === AI_SETTING_KEY);
    if (!match) return true;
    return match.value === "true";
  } catch {
    return true;
  }
}

export async function getMaintenanceModeEnabled(): Promise<boolean> {
  try {
    const settings = await fetchPublicSystemSettings();
    const match = settings.find(
      (setting) => setting.key === MAINTENANCE_SETTING_KEY
    );
    if (!match) return false;
    return match.value === "true";
  } catch {
    return false;
  }
}

export async function getAddressAutocompleteEnabled(): Promise<boolean> {
  try {
    const settings = await fetchPublicSystemSettings();
    const match = settings.find(
      (setting) => setting.key === ADDRESS_AUTOCOMPLETE_SETTING_KEY
    );
    if (!match) return true;
    return match.value === "true";
  } catch {
    return true;
  }
}

export async function getMlSmartSearchEnabled(): Promise<boolean> {
  try {
    const settings = await fetchPublicSystemSettings();
    const match = settings.find(
      (setting) => setting.key === ML_SMART_SEARCH_SETTING_KEY
    );
    if (!match) return true;
    return match.value === "true";
  } catch {
    return true;
  }
}
